import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CrossIcon from 'jl-design-system/elements/icons-jb/Close24PxOutlined';

import styles from './typeahead-overlay.scss';

const BrandPromiseCloseButton = ({ isTypeaheadOpen, onCloseButtonClick }) => {
  const closeButtonClasses = classNames([styles.bpCloseButton], {
    [styles.bpCloseButton__hidden]: !isTypeaheadOpen,
  });

  return (
    <button
      data-testid="close-expanded-search"
      className={closeButtonClasses}
      onClick={onCloseButtonClick}
    >
      <CrossIcon className={classNames(styles.closeIcon)} />
      <p>Close</p>
    </button>
  );
};

BrandPromiseCloseButton.propTypes = {
  isTypeaheadOpen: PropTypes.bool.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
};

export default BrandPromiseCloseButton;
